function isIngame() {
    var _a, _b;
    return ((_b = (_a = window === null || window === void 0 ? void 0 : window.navigator) === null || _a === void 0 ? void 0 : _a.userAgent) === null || _b === void 0 ? void 0 : _b.includes('MKclient/1.0')) || false;
}

export { isIngame };
//# sourceMappingURL=checkIngame.js.map
